import { Images } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const media = defineDashboardModule({
  id: "media",
  nav: [{ group: "Publishing", title: "Media", to: "/media", icon: Images }],
  routes: [
    {
      path: "/media",
      component: lazyPage(
        () => import("./routes/media-library"),
        "MediaLibraryPage"
      ),
    },
  ],
})
